
import {
    computed,
    defineComponent,
    isRef,
    onMounted,
    ref,
    toRef,
    watch
} from "vue";

export default defineComponent({
    name: "CigoIconFont",
    props: {
        name: {
            type: String,
            default: ""
        },
        color: {
            type: String,
            default: "#ffffff"
        }
    },
    setup(props) {
        let iconName = computed(() => {
            return `#${props.name}`;
        });
        return {
            iconName
        };
    }
});
